// extracted by mini-css-extract-plugin
export var modal = "_m5-0";